import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiSend, FiCheckCircle, FiMail, FiUser, FiAlertCircle, FiHeadphones, FiZap, FiClock, FiMessageCircle } from 'react-icons/fi';
import Navbar from '../shared/Navbar.jsx';
import BottomNav from '../shared/BottomNav.jsx';
import { getApiBaseUrl } from '../../utils/apiBaseUrl';
import '../home/Home.css';
import './Contact.css';

const apiBaseUrl = getApiBaseUrl();

const SUJETS = [
	'Question sur une réservation',
	'Problème avec un véhicule',
	'Remboursement',
	'Signaler une agence',
	'Problème de connexion / compte',
	'Proposition partenariat',
	'Autre',
];

const INFOS = [
	{ icon: FiMail,    titre: 'Email',            valeur: 'ultimatexdrive@gmail.com', href: 'mailto:ultimatexdrive@gmail.com' },
	{ icon: FiClock,   titre: 'Délai de réponse', valeur: 'Moins de 24h en semaine',   href: null },
	{ icon: FiZap,     titre: 'Réponse instantanée', valeur: 'Assistant IA disponible', href: '/assistant-ia', linkLabel: 'Ouvrir l\'assistant' },
];

function Contact() {
	const [form, setForm] = useState({ fullName: '', email: '', subject: '', message: '' });
	const [erreur, setErreur] = useState('');
	const [succes, setSucces] = useState(false);
	const [chargement, setChargement] = useState(false);

	const handleChamp = (e) => {
		const { name, value } = e.target;
		setForm((p) => ({ ...p, [name]: value }));
	};

	const handleSoumission = async (e) => {
		e.preventDefault();
		setErreur('');

		if (!form.fullName.trim()) { setErreur('Votre nom est obligatoire.'); return; }
		if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) { setErreur('Adresse email invalide.'); return; }
		if (!form.subject) { setErreur('Choisissez un sujet.'); return; }
		if (!form.message.trim() || form.message.trim().length < 20) { setErreur('Le message doit contenir au moins 20 caractères.'); return; }

		setChargement(true);
		try {
			const res = await fetch(`${apiBaseUrl}/api/complaints`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					fullName: form.fullName.trim(),
					email: form.email.trim().toLowerCase(),
					subject: form.subject,
					message: form.message.trim(),
					priority: 'medium',
				}),
			});
			const data = await res.json().catch(() => ({}));
			if (!res.ok) throw new Error(data?.message || 'Envoi impossible.');
			setSucces(true);
			setForm({ fullName: '', email: '', subject: '', message: '' });
		} catch (err) {
			setErreur(err.message || 'Une erreur est survenue. Veuillez réessayer.');
		} finally {
			setChargement(false);
		}
	};

	return (
		<div className="ct-page">
			<Navbar />

			<main className="ct-main">
				{/* ── HERO ── */}
				<section className="ct-hero">
					<div className="ct-hero-glow" aria-hidden="true" />
					<div className="vx-shell ct-hero-inner">
						<div className="ct-hero-kicker">
							<FiHeadphones size={13} aria-hidden="true" /> Support client
						</div>
						<h1 className="ct-hero-title">
							On est là<br /><em>pour vous.</em>
						</h1>
						<p className="ct-hero-sub">
							Une question, un problème ou une suggestion ? Utilisez le formulaire ci-dessous ou contactez-nous directement. Notre équipe répond sous 24h.
						</p>
					</div>ultimatexdrive@gmail.com
				</section>

				<div className="vx-shell ct-body">

					{/* ── INFOS ── */}
					<aside className="ct-aside">
						<div className="ct-aside-inner">
							<h2 className="ct-aside-title">Autres façons de nous joindre</h2>

							{INFOS.map((info) => (
								<div key={info.titre} className="ct-info-card">
									<div className="ct-info-icon">
										<info.icon size={18} aria-hidden="true" />
									</div>
									<div className="ct-info-text">
										<strong>{info.titre}</strong>
										{info.href ? (
											info.href.startsWith('/') ? (
												<Link to={info.href}>{info.linkLabel || info.valeur}</Link>
											) : (
												<a href={info.href}>{info.valeur}</a>
											)
										) : (
											<span>{info.valeur}</span>
										)}
									</div>
								</div>
							))}

							<div className="ct-aside-note">
								<FiMessageCircle size={14} aria-hidden="true" />
								<p>Pour les urgences liées à une réservation en cours, mentionnez votre numéro de réservation dans le message.</p>
							</div>
						</div>
					</aside>

					{/* ── FORMULAIRE ── */}
					<div className="ct-form-wrap">
						{succes ? (
							<div className="ct-success">
								<div className="ct-success-icon">
									<FiCheckCircle size={36} aria-hidden="true" />
								</div>
								<h2>Message envoyé !</h2>
								<p>Merci de nous avoir contactés. Notre équipe vous répondra dans les plus brefs délais.</p>
								<button type="button" className="ct-btn-blue" onClick={() => setSucces(false)}>
									Envoyer un autre message
								</button>
							</div>
						) : (
							<form className="ct-form" onSubmit={handleSoumission} noValidate>
								<div className="ct-form-header">
									<h2>Envoyez-nous un message</h2>
									<p>Tous les champs marqués sont obligatoires.</p>
								</div>

								<div className="ct-row">
									<div className="ct-field">
										<label htmlFor="ct-name">
											<FiUser size={11} /> Nom complet
										</label>
										<input
											id="ct-name"
											name="fullName"
											type="text"
											placeholder="Jean Dupont"
											value={form.fullName}
											onChange={handleChamp}
											required
										/>
									</div>
									<div className="ct-field">
										<label htmlFor="ct-email">
											<FiMail size={11} /> Email
										</label>
										<input
											id="ct-email"
											name="email"
											type="email"
											placeholder="vous@email.com"
											value={form.email}
											onChange={handleChamp}
											required
										/>
									</div>
								</div>

								<div className="ct-field">
									<label htmlFor="ct-subject">Sujet</label>
									<div className="ct-select-wrap">
										<select
											id="ct-subject"
											name="subject"
											value={form.subject}
											onChange={handleChamp}
											required
										>
											<option value="">Choisissez un sujet…</option>
											{SUJETS.map((s) => (
												<option key={s} value={s}>{s}</option>
											))}
										</select>
									</div>
								</div>

								<div className="ct-field">
									<label htmlFor="ct-message">Message</label>
									<textarea
										id="ct-message"
										name="message"
										placeholder="Décrivez votre demande en détail…"
										value={form.message}
										onChange={handleChamp}
										rows={6}
										required
									/>
									<span className="ct-char-count">{form.message.length} / 20 min.</span>
								</div>

								{erreur && (
									<div className="ct-error" role="alert">
										<FiAlertCircle size={14} /> {erreur}
									</div>
								)}

								<button type="submit" className="ct-btn-blue ct-submit" disabled={chargement}>
									{chargement ? 'Envoi en cours…' : <><FiSend size={14} /> Envoyer le message</>}
								</button>
							</form>
						)}
					</div>
				</div>
			</main>

			<BottomNav />
		</div>
	);
}

export default Contact;
